import { Component, OnInit,ViewEncapsulation, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
@Component({
  selector: 'app-terms-giverecharge',
  templateUrl: './terms-giverecharge.component.html',
  styleUrls: ['./terms-giverecharge.component.sass']
})
export class TermsGiverechargeComponent implements OnInit {

  constructor(public matDialogRef:MatDialogRef<TermsGiverechargeComponent>,@Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
  }
  public close(){;
    this.matDialogRef.close('cancel');
  }
}
